export class TranslationLoadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TranslationLoadError';
  }
}
